import styled from 'styled-components';
import { AiColor16 } from 'ui/icons';
import { Caption, Subtitle2 } from 'ui/theme';

export const DisabledCaption = styled(Caption)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const EditorSummaryBackground = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${({ theme }) => `${theme.spacing.utils.pxToRem(52)} 1fr`};
  border-radius: ${({ theme }) => theme.spacing.values.half};
  padding-top: ${({ theme }) => theme.spacing.values.base};
  margin-bottom: ${({ theme }) => theme.spacing.values.base};
  background-color: ${({ theme }) => theme.colors.neutrals.grey1};
  height: ${({ theme }) => theme.spacing.utils.pxToRem(82)};
  width: 100%;
`;
export const EditorSummaryIcon = styled(AiColor16)`
  height: 20px;
  width: 20px;
  justify-self: center;
`;
export const EditorSummaryText = styled(Subtitle2)`
  margin: 0;
  line-height: 1;
  padding-bottom: ${({ theme }) => theme.spacing.values.quarter};
`;
export const EditorSummarySubtext = DisabledCaption;

export const ChannelSelectText = styled(Subtitle2)`
  margin: 0;
`;
export const ChannelSubText = styled(DisabledCaption)`
  display: inline-block;
  margin: ${({ theme }) => `0 0 ${theme.spacing.values.threeQuarter} 0`};
`;

export const NoChannelsEnabledCaption = styled(DisabledCaption)`
  margin: ${({ theme }) => `0 0 0 ${theme.spacing.values.threeEights}`};
`;

export const NoChannelsEnableContainer = styled.p`
  display: flex;
  align-items: center;
`;

export const PriorityContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing.values.double};
`;
